'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _dec,_desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseUserProfileController=require('./baseUserProfileController');
const HandleUncaughtErrors=require('../../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const SocketResponse=require('../../../../../../dist-es6/client/dtos/socketResponse');let

EditUserModalController=(_dec=


































HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=function(_BaseUserProfileContr){_inherits(EditUserModalController,_BaseUserProfileContr);_createClass(EditUserModalController,null,[{key:'$inject',get:function(){return['$modalInstance','user','userService','uiCommandFactory','onUserUpdated','uncaughtErrorHandler']}}]);function EditUserModalController($modalInstance,user,userService,uiCommandFactory,onUserUpdated,uncaughtErrorHandler){_classCallCheck(this,EditUserModalController);var _this=_possibleConstructorReturn(this,_BaseUserProfileContr.call(this,uncaughtErrorHandler,user));_this._userService=userService;_this._$modalInstance=$modalInstance;_this._onUserUpdated=onUserUpdated;_this._updateUserCommand=uiCommandFactory.makeForModal($modalInstance,_this._updateCurrentUser.bind(_this));_this.emailErrorHandler=_this.emailErrorHandler.bind(_this);return _this}EditUserModalController.prototype.onCancel=function onCancel(){this._$modalInstance.dismiss()};EditUserModalController.prototype.emailErrorHandler=function emailErrorHandler(submissionResult){if(_.exists(submissionResult)){if(submissionResult.status==='HttpError'&&submissionResult.body.httpStatus===409){return`Email address "${this.email}" is already in use.`}}};EditUserModalController.prototype.
_updateCurrentUser=function(){var ref=_asyncToGenerator(function*(){
let updateResult=yield this._userService.updateCurrentUserInfo({
firstName:this.firstName,
lastName:this.lastName,
phone:this.phone,
email:this.email});


this._submissionResult=updateResult;

if(!SocketResponse.succeeded(updateResult)){
return ModalSubmissionResult.KeepOpen;
}

this._onUserUpdated();

return ModalSubmissionResult.Close();
});function _updateCurrentUser(){return ref.apply(this,arguments)}return _updateCurrentUser}();_createClass(EditUserModalController,[{key:'updateUserCommand',get:function(){return this._updateUserCommand}},{key:'submissionResult',get:function(){return this._submissionResult}}]);return EditUserModalController}(BaseUserProfileController),(_applyDecoratedDescriptor(_class.prototype,'_updateCurrentUser',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_updateCurrentUser'),_class.prototype)),_class));


module.exports=EditUserModalController;
//# sourceMappingURL=editUserModalController.js.map
